module.exports = __webpack_public_path__ + "img/maj0.8a529797.jpg";